import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { AnaliseCritica } from "features/projetos/models/AnaliseCritica";

async function createAnaliseCritica(analiseCritica: AnaliseCritica): Promise<IResponse<ValidationResult>> {
  return await axios.post('/AnaliseCritica/Cadastrar', analiseCritica);
}

export default createAnaliseCritica;